

























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";

class PageUserRequest extends PageRequest {
  areaId: number;
  startTime: string;
  endTime: string;
  meterId: string;
  operaType: number = 0;
}
@Component({
  components: {},
})
export default class LineLossDetail extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) meterId: string;
  @Prop({ type: String, default: "" }) startTime: string;
  @Prop({ type: String, default: "" }) endTime: string;
  pagerequest: PageUserRequest = new PageUserRequest();
  loading: boolean = false;
  rowCount: number = 0;
  list: any[] = [];
  pageSize: number = 10;
  currentPagenum: number = 1;
  create() { }
  created() { }
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = val[0];
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPagenum - 1) * this.pageSize;
    this.getpage();
  }
  data() {
    return {
      arealist: [],
      pageSizeOpts: [10, 30, 50, 100, 200],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
  pageChange(page: number) {
    this.currentPagenum = page;
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.pageSize = pagesize;
    this.getpage();
  }
  changeSort(key) {
    this.getpage();
  }
  async getpage() {
    this.loading = true;
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPagenum - 1) * this.pageSize;
    await this.$store
      .dispatch({
        type: "readrecord/getLineLossDetail",
        data: this.pagerequest,
      })
      .then((val: any) => {
        this.loading = false;
        //this.$store.state.readrecord.totalCount = val.rowCount;
        //this.$store.state.readrecord.list = val.tableData;
        console.log(val)
        this.rowCount = val.rowCount;
        this.list = val.tableData;
      })
      .catch((err) => {
        this.loading = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.loading = false;
  }
  //列名称
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      fixed: "left",
      align: "center",
      sortId: 1,
    },
    {
      sortable: true,
      title: this.L("Meter"),
      key: "meterNo",
      resizable: true,
      width: 130,
      fixed: "left",
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("ChildrenNum"),
      key: "totalCount",
      sortable: true,
      width: 130,
    },

    {
      sortable: true,
      title: this.L("Location"),
      key: "location",
      resizable: true,
      width: 130,
      fixed: "left",
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("TotalUse"),
      key: "totalUse",
      width: 130,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.totalUse.toFixed(2),
            },
          },
          params.row.totalUse.toFixed(2)
        );
      },
    },
    {
      title: this.L("ChildTotalUse"),
      key: "childTotalUse",
      width: 130,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.childTotalUse.toFixed(2),
            },
          },
          params.row.childTotalUse.toFixed(2)
        );
      },
    },
    {
      title: this.L("DiffTotalUse"),
      key: "diffTotalUse",
      width: 130,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.diffTotalUse.toFixed(2),
            },
          },
          params.row.diffTotalUse.toFixed(2)
        );
      },
    },
    {
      title: this.L("LineLossRate"),
      key: "lineLossRate",
      width: 130,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: (params.row.lineLossRate * 100).toFixed(2) + '%',
            },
          },
          (params.row.lineLossRate * 100).toFixed(2) + '%'
        );
      },
    },
    {
      title: this.L("StartTime"),
      key: "startReadTime",
      width: 150,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.startReadTime == null
            ? ""
            : Moment(params.row.startReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("EndTime"),
      key: "lastReadTime",
      width: 150,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : Moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Organizations"),
      key: "organizationName",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.organizationName,
            },
          },
          params.row.organizationName
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      sortable: true,
      title: this.L("CollectorId"),
      key: "collectorNo",
      resizable: true,
      width: 130,
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.collectorNo,
            },
          },
          params.row.collectorNo
        );
      },
    },
  ];
  @Watch("meterId", { deep: true })
  @Watch("startTime", { deep: true })
  @Watch("endTime", { deep: true })
  getitemId() {
    //console.log(this.meterId);
    this.pagerequest.meterId = this.meterId;
    this.pagerequest.startTime = this.startTime;
    this.pagerequest.endTime = this.endTime;
  }
}
